import NextLink from "next/link";
import {cn} from "@/src/shared/utils/mergeTwClasses";
import {Box as MuiBox, Typography as MuiTypography} from "@mui/material";
import {WebShopIcon} from "@/src/components/WebShopIcon";

export function Pdf(props: any) {
    return (
        <NextLink
            href={props.src}
            target={props.target}
            prefetch={false}
            className={cn(props.className, "flex items-center gap-4")}
        >
            <MuiBox className="h-14 w-14 max-mdPlus:h-8 max-mdPlus:w-7">
                <WebShopIcon
                    name={props.iconName}
                    height={props.iconSize}
                    width={props.iconSize}
                    className="h-12 w-9 stroke-blue max-mdPlus:h-9 max-mdPlus:w-7"
                />
            </MuiBox>
            <MuiTypography className="text-[15px] font-normal text-blue underline">
                {props.label || "PDF файл"}
            </MuiTypography>
        </NextLink>
    );
}